console.log('Stockists initiated');
// console.log('stockists', nk_stockist_vars);

let map;
const siteRoot = window.location.protocol + '//' + window.location.host;

const stockistList = nk_stockist_vars.stockistsList;
// console.log(typeof stockistList, stockistList);
const customLat = parseFloat(nk_stockist_vars.visitor_geo_data?.geoplugin_latitude) || 54.13437973373494;
const customLng = parseFloat(nk_stockist_vars.visitor_geo_data?.geoplugin_longitude) || -0.7704833162775102;

const customMapData = {
    initialZoom: 9,
    zoom: 9,
    center: {
        lat: customLat,
        lng: customLng,
    },
    stockistList: stockistList,
    mapStyle: nk_stockist_vars.mapStyle,
};

function initMap() {
    console.log('Map initiated');

    // Create the map.
    const map = new google.maps.Map(document.getElementById('map'), {
        zoom: customMapData.initialZoom,
        center: customMapData.center,
        styles: customMapData.mapStyle,
        streetViewControl: false,
    });

    map.data.addGeoJson(customMapData.stockistList, {
        idPropertyName: 'storeid',
    });

    const infoWindow = new google.maps.InfoWindow();
    // Set the origin point when the user selects an address
    const originMarker = new google.maps.Marker({ map: map });
    originMarker.setVisible(false);
    let originLocation = map.getCenter();

    // Show the information for a store when its marker is clicked.
    map.data.addListener('click', (event) => {
        const category = event.feature.getProperty('category');
        const name = event.feature.getProperty('name');
        let description = event.feature.getProperty('description');
        const hours = event.feature.getProperty('hours');
        const phone = event.feature.getProperty('phone');
        const position = event.feature.getGeometry().get();
        const stockistCollections = event.feature.getProperty('collections');
        const collectionsText =
            stockistCollections.length == 1
                ? `${stockistCollections[0]}`
                : `${stockistCollections[0]} and ${stockistCollections[1]}`;
        const content = `
        <h2>${name}</h2><p class="marker-description">${description}</p>
        <p>${collectionsText} collection available here.</p>
        `;

        infoWindow.setContent(content);
        infoWindow.setPosition(position);
        infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
        infoWindow.open(map);
    });

    map.addListener('bounds_changed', async () => {
        const stockistsOnMap = await calculateMapView(map.data);
        // console.log('stockistsOnMap', stockistsOnMap);
        showStoresList(map.data, stockistsOnMap);
    });

    // ***
    // Create collection filter
    // ***
    const collectionChecboxes = document.getElementsByName('collection');
    const collectionSelected = Array.from(document.querySelectorAll("input[name='collection']:checked")).map(
        (elem) => elem.value
    );
    collectionChecboxes.forEach((collectionChecbox) => {
        collectionChecbox.addEventListener('change', (e) => {
            e.stopPropagation();
            e.stopImmediatePropagation();
            // Allow only 1 selection
            let state = e.target.checked; // save state of changed checkbox
            collectionChecboxes.forEach((col) => (col.checked = false)); // clear all checkboxes
            e.target.checked = state;

            const collectionSelected = Array.from(document.querySelectorAll("input[name='collection']:checked")).map(
                (elem) => elem.value
            );

            // console.log('collectionSelected', collectionSelected);

            map.data.forEach((store) => {
                // console.log('store', store);
                const storeCollections = store.getProperty('collections');

                if (collectionSelected.length == 0) {
                    // show all
                    store.setProperty('isVisible', true);
                } else {
                    // show selected
                    if (storeCollections.includes(collectionSelected[0])) {
                        store.setProperty('isVisible', true);
                    } else {
                        store.setProperty('isVisible', false);
                    }
                }
            });
            updateMapStyle();
            customMapData.zoom = map.getZoom();
            updateMapContent();
        });
    });

    // ***
    // Click on panel place
    // ***
    const panelPlace = document.querySelector('#stockist-list-panel');
    panelPlace.addEventListener('click', (e) => {
        // console.log(e);
        if (e.target.classList.contains('place-title')) {
            const place = e.target.closest('.place');
            const storeID = place.getAttribute('store-id');
            const selectedStore = map.data.getFeatureById(storeID);

            map.setCenter(selectedStore.getGeometry().get());
            selectedStore.click();
        }
    });

    // ***
    // Geolocation
    // ***
    const locationButton = document.getElementById('user-geolocation');
    locationButton.addEventListener('click', () => {
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };

                    infoWindow.setPosition(pos);
                    infoWindow.setContent('Your location');
                    infoWindow.open(map);
                    map.setCenter(pos);
                    originLocation = map.getCenter();
                    customMapData.zoom = customMapData.initialZoom;
                    updateMapContent();
                },
                () => {
                    handleLocationError(true, infoWindow, map.getCenter());
                }
            );
        } else {
            // Browser doesn't support Geolocation
            handleLocationError(false, infoWindow, map.getCenter());
        }
        return;
    });

    function handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? 'Error: The Geolocation service failed.'
                : "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(map);
    }
    // ***
    // Create search field
    // ***
    const searchInput = document.getElementById('search-input');
    const searchOptions = {
        types: ['geocode'],
        // componentRestrictions: {country: 'gb'},
    };
    const autocomplete = new google.maps.places.Autocomplete(searchInput, searchOptions);
    autocomplete.setFields(['address_components', 'geometry', 'name']);

    // ***
    // React to search change
    // ***

    autocomplete.addListener('place_changed', async () => {
        originMarker.setVisible(false);
        originLocation = map.getCenter();
        const place = autocomplete.getPlace();

        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert("No address available for input: '" + place.name + "'");
            return;
        }

        // Recenter the map to the selected address
        originLocation = place.geometry.location;
        map.setCenter(originLocation);

        originMarker.setPosition(originLocation);
        originMarker.setVisible(true);
        customMapData.zoom = customMapData.initialZoom;
        updateMapContent();

        return;
    });

    // ***
    // Create list
    // ***
    async function calculateDistances(data, origin) {
        const stores = [];
        const destinations = [];

        // Build parallel arrays for the store IDs and destinations
        data.forEach((store) => {
            const storeNum = store.getProperty('storeid');
            const storeLoc = store.getGeometry().get();

            stores.push(storeNum);
            destinations.push(storeLoc);
        });

        // Retrieve the distances of each store from the origin
        // The returned list will be in the same order as the destinations list
        const service = new google.maps.DistanceMatrixService();
        const getDistanceMatrix = (service, parameters) =>
            new Promise((resolve, reject) => {
                service.getDistanceMatrix(parameters, (response, status) => {
                    if (status != google.maps.DistanceMatrixStatus.OK) {
                        reject(response);
                    } else {
                        const distances = [];
                        const results = response.rows[0].elements;
                        for (let j = 0; j < results.length; j++) {
                            const element = results[j];
                            const distanceText = element.distance.text;
                            const distanceVal = element.distance.value;
                            const distanceObject = {
                                storeid: stores[j],
                                distanceText: distanceText,
                                distanceVal: distanceVal,
                            };
                            distances.push(distanceObject);
                        }

                        resolve(distances);
                    }
                });
            });

        const distancesList = await getDistanceMatrix(service, {
            origins: [origin],
            destinations: destinations,
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.METRIC,
        });

        distancesList.sort((first, second) => {
            return first.distanceVal - second.distanceVal;
        });

        return distancesList;
    }

    async function calculateMapView(data) {
        const storesOnMap = [];

        data.forEach((store) => {
            const storeNum = store.getProperty('storeid');
            const storeIsVisible = store.getProperty('isVisible');
            const storeLoc = store.getGeometry().get().toJSON();

            if (map.getBounds().contains(storeLoc) && storeIsVisible) {
                const onMapObject = {
                    storeid: storeNum,
                };
                storesOnMap.push(onMapObject);
            }
        });

        // Retrieve the distances of each store from the origin
        // The returned list will be in the same order as the destinations list
        // console.log('storesOnMap', storesOnMap);
        return storesOnMap;
    }

    function showStoresList(data, stores) {
        let stockistListPanel = document.getElementById('stockist-list-panel');

        // Clear the previous details
        while (stockistListPanel.lastChild) {
            stockistListPanel.removeChild(stockistListPanel.lastChild);
        }

        if (stores.length < 1) {
            const wrapper = document.createElement('div');
            wrapper.classList.add(`place`, `place-none`);

            const name = document.createElement('h2');
            name.textContent = `No stockists in selected area`;

            const address = document.createElement('p');
            address.textContent = 'Please zoom out map to find closest stockists';

            wrapper.appendChild(name);
            wrapper.appendChild(address);
            stockistListPanel.appendChild(wrapper);
        }

        stores.forEach((store) => {
            // console.log('showStoresList -> store', store);
            // Add store details with text formatting
            const currentStore = data.getFeatureById(store.storeid);
            const stockistCollections = currentStore.getProperty('collections');
            const collectionsText =
                stockistCollections.length == 1
                    ? `${stockistCollections[0]}`
                    : `${stockistCollections[0]} and ${stockistCollections[1]}`;
            const directionsDistance = store.distanceText ? ` (${store.distanceText})` : '';
            const stockistLocation = currentStore.getGeometry().get().toUrlValue();
            //console.log('stockistLocation', stockistLocation);
            const directionURL = `https://www.google.com/maps/dir/?api=1&destination=${stockistLocation}`;

            const wrapper = `
            <div class="place place-${store.storeid}" store-id="${store.storeid}">
                <div class="top-row">
                    <h2 class="place-title">${currentStore.getProperty('name')}</h2>
                    <span class="distance">
                        <a href="${directionURL}" target="_blank" rel="noopener noreferrer">Directions ${directionsDistance}</a>
                    </span>
                </div>
                <p class="address">${currentStore.getProperty('description')}</p>
                <p class="collection">${collectionsText} collection available here.</p>
            </div>`;
            stockistListPanel.insertAdjacentHTML('beforeend', wrapper);
        });

        return;
    }
    let whileStockistsOnMap;
    async function updateMapContent() {
        let mapZoom = 14;
        map.setZoom(mapZoom);
        // console.log('updateMapContent fired');
        let whileStockistsOnMap = await calculateMapView(map.data);
        while (whileStockistsOnMap.length < 5) {
            mapZoom--;
            map.setZoom(mapZoom);
            whileStockistsOnMap = await calculateMapView(map.data);
        }
        let stockistsOnMap = whileStockistsOnMap;
        // console.log('stockistsOnMap.length', stockistsOnMap.length);
        if (stockistsOnMap.length > 0 && stockistsOnMap.length < 15) {
            let stockistsForDistance = [];
            const selectedStockists = stockistsOnMap.map((a) => a.storeid);

            map.data.forEach((store) => {
                if (selectedStockists.includes(store.getProperty('storeid'))) {
                    stockistsForDistance.push(store);
                }
            });
            // console.log('originLocation', originLocation);
            stockistsOnMap = await calculateDistances(stockistsForDistance, originLocation);
            showStoresList(map.data, stockistsOnMap);
        } else {
            showStoresList(map.data, stockistsOnMap);
        }
    }
    function updateMapStyle() {
        const customIcon = `${siteRoot}/wp-content/themes/crootsengland/assets/images/ico-location-pin.svg`;
        map.data.setStyle(function (store) {
            let visible = true;

            const storeCollection = store.getProperty('collections');
            // const icon = customIcons[storeCollection] || {};
            // console.log('store', store);
            const storeVivibleProperty = store.getProperty('isVisible');

            if (store.getProperty('isVisible') === true) {
                visible = true;
            } else {
                visible = false;
            }
            return {
                icon: {
                    url: customIcon,
                    scaledSize: new google.maps.Size(20, 30),
                    // The anchor for this image is the base (0, 12).
                    anchor: new google.maps.Point(10, 30),
                },
                visible: visible,
            };
        });
    }
    updateMapStyle();

    map.data.addListener('click', function (event) {
        // console.log(event.feature.getProperty('isVisible'));
    });
}

window.initMap = initMap;
